
    <div id="stars">
      <div *ngFor="let star of stars">
        <mat-icon
          ngClass="{{ star }} {{ size }}"
          [ngStyle]="{'color': color}">
          {{ star }}
        </mat-icon>
      </div>
    </div>
  